<template>
  <form class="t-lk-search t-lk-filter-item" @submit.prevent="submitSearch">
    <input class="t-lk-filter-item__input" type="text" :placeholder="$root.staticText.forms.placeholderCompany2" v-model="search" />
    <svg @click="submitSearch" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.36735 3.30612C7.02503 3.30612 5.73768 3.83936 4.78852 4.78852C3.83936 5.73768 3.30612 7.02503 3.30612 8.36735C3.30612 9.032 3.43703 9.69014 3.69139 10.3042C3.94574 10.9182 4.31854 11.4762 4.78852 11.9462C5.2585 12.4162 5.81644 12.789 6.4305 13.0433C7.04456 13.2977 7.7027 13.4286 8.36735 13.4286C9.032 13.4286 9.69014 13.2977 10.3042 13.0433C10.9182 12.789 11.4762 12.4162 11.9462 11.9462C12.4162 11.4762 12.789 10.9182 13.0433 10.3042C13.2977 9.69014 13.4286 9.032 13.4286 8.36735C13.4286 7.02503 12.8953 5.73768 11.9462 4.78852C10.997 3.83936 9.70967 3.30612 8.36735 3.30612ZM3.86495 3.86495C5.05906 2.67084 6.67862 2 8.36735 2C10.0561 2 11.6756 2.67084 12.8697 3.86495C14.0638 5.05906 14.7347 6.67862 14.7347 8.36735C14.7347 9.20352 14.57 10.0315 14.25 10.804C14.0136 11.3747 13.696 11.9068 13.3078 12.3842L17.8087 16.8852C18.0638 17.1402 18.0638 17.5537 17.8087 17.8087C17.5537 18.0638 17.1402 18.0638 16.8852 17.8087L12.3842 13.3078C11.9068 13.696 11.3747 14.0136 10.804 14.25C10.0315 14.57 9.20352 14.7347 8.36735 14.7347C7.53118 14.7347 6.70319 14.57 5.93067 14.25C5.15815 13.93 4.45622 13.461 3.86495 12.8697C3.27369 12.2785 2.80467 11.5765 2.48469 10.804C2.1647 10.0315 2 9.20352 2 8.36735C2 6.67862 2.67084 5.05906 3.86495 3.86495Z"
        fill="#C0C0CC"
      />
    </svg>
  </form>
</template>

<script>
export default {
  name: 'lk-search',
  props: {
    objUndefined: Object,
    animation: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      search: null,
    }
  },
  methods: {
    submitSearch() {
      if (this.search === '') {
        this.search = undefined
      }
      if (this.$route.query.q !== this.search) {
        this.$router.push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, { q: this.search }, this.objUndefined, { animation: this.animation }),
        })
      }
    },
  },
  mounted() {
    this.search = this.$route.query.q
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-search/lk-search.vue